import { IResourceComponentsProps, useExport, useNavigation, useShow } from '@pankod/refine-core'
import { EvaluationRequestsList } from 'components/evaluation_requests'
import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  useTable,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  ShowButton,
  Typography,
} from '@pankod/refine-antd'

import { IEvaluationRequests } from 'interfaces'
// import { CreateTestEvent } from './create'
// import { EditTestEvent } from './edit'
const { PlusOutlined } = Icons
const { Text, Link } = Typography

export const EvaluationRequests: React.FC<IResourceComponentsProps> = () => {
  const { triggerExport, isLoading } = useExport<IEvaluationRequests>()
  return <EvaluationRequestsList />
}
